import styled, { css } from 'styled-components';

export const TabsWrapper = styled.div<{ $vertical?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.35rem;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  padding-bottom: 2px;

  &::-webkit-scrollbar {
    display: none;
  }

  ${({ $vertical }) =>
    $vertical &&
    css`
      flex-direction: column;
      align-items: stretch;
      overflow: visible;
      margin-top: 0;
      padding-bottom: 0;
      gap: 0.25rem;
    `}
`;

export const TabButton = styled.button<{ $active?: boolean; $vertical?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.7rem;
  background: ${({ $active }) => ($active ? '#19334d' : 'transparent')};
  color: ${({ $active }) => ($active ? '#fff' : '#19334d')};
  border: none;
  border-radius: 12px;
  font-size: 0.95rem;
  font-weight: 600;
  padding: 0.45rem 1.25rem;
  white-space: nowrap;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: ${({ $active }) => ($active ? '0 4px 16px 0 rgba(25, 51, 77, 0.1)' : 'none')};
  transition: background 0.18s, color 0.18s;

  &:hover {
    background: #22304a;
    color: #fff;
  }

  ${({ $vertical }) =>
    $vertical &&
    css`
      width: 100%;
      justify-content: flex-start;
      padding: 0.7rem 0.9rem;
      font-size: 0.9rem;
      border-radius: 10px;
    `}
`;

export const TabIcon = styled.span`
  display: flex;
  align-items: center;
  font-size: 1.1rem;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const TabLabel = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: inherit;
  font-weight: 600;
`;
